<template>
<div>
  <label for="userID">{{$vuetify.lang.t('$vuetify.username')}}</label>
  <div class="cui-error" v-if="$v.userLogin.userId.$error && !$v.userLogin.userId.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
  </div>
  <div class="cui-error" v-else-if="$v.userLogin.userId.$error && !$v.userLogin.userId.isUnique" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-username-taken')}}</div>
  </div>
 <input type="text" v-model="userLogin.userId" @blur="$v.userLogin.userId.$touch()"
       name="userId" class="cui-input"/>
  <div class="cui-wizard__field-row">
    <!-- Password -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <div class="cui-input__password-holder">
        <label>{{$vuetify.lang.t('$vuetify.cui-password')}}</label>
      <div class="cui-error" v-if="$v.userLogin.password.$error && !$v.userLogin.password.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
       <!--<div class="cui-error" v-if="$v.userLogin.password.$error && !$v.userLogin.password.minLength" >
        <div class="cui-error__message">Password should contain minimum 6 characters</div>
      </div>
      <div class="cui-error" v-if="$v.userLogin.password.$error && !$v.userLogin.password.maxLength" >
        <div class="cui-error__message">Password can contain maximum 99 characters</div>
      </div> -->
        <input type="password" v-model="userLogin.password" @blur="$v.userLogin.password.$touch()"
       name="password" :class="[$v.userLogin.password.$error  ? 'cui-input--error': 'cui-input' ]" id="textIinput"/>
      </div>
  <b-popover target="textIinput" v-if="$v.userLogin.password.$error" triggers="hover" placement="right">
     <p>{{$vuetify.lang.t('$vuetify.passwords-must')}}</p>
    <div class="cui-error__message" v-if="!$v.userLogin.password.isMinMax">have between 6-99 characters</div>
    <div v-if="!$v.userLogin.password.isRequiredNumberCharClass">
    <p>have 1 of the following</p>
    <div class="cui-error__message" v-if="!$v.userLogin.password.isLowerCase">{{$vuetify.lang.t('$vuetify.password-lowercase')}}</div>
    <div class="cui-error__message" v-if="!$v.userLogin.password.isUpperCase">{{$vuetify.lang.t('$vuetify.password-uppercase')}}</div>
    <div class="cui-error__message" v-if="!$v.userLogin.password.isNumber">{{$vuetify.lang.t('$vuetify.password-number')}}</div>
     <div class="cui-error__message" v-if="!$v.userLogin.password.isSpecialChars">{{$vuetify.lang.t('$vuetify.password-special')}}</div>
    </div>
   <!--<li>{{$vuetify.lang.t('$vuetify.password-special')}}</li>-->
  </b-popover>
    </div>
  <div class=".cui-loading__container--organization-list" v-if="spinner">
    <div class="cui-loading--center"><div class="cui-loading"></div></div>
  </div>
    <!-- Re-enter Password -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label> {{$vuetify.lang.t('$vuetify.cui-password-re')}}</label>
          <div class="cui-error" v-if="$v.userLogin.passwordRe.$error && !$v.userLogin.passwordRe.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <div class="cui-error" v-else-if="$v.userLogin.passwordRe.$error && !$v.userLogin.passwordRe.sameAsPassword" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.password-mismatch')}}</div>
      </div>
        <input type="password" v-model="userLogin.passwordRe" @blur="$v.userLogin.passwordRe.$touch()"
       name="passwordRe" class="cui-input" />
    </div>
  </div>
  <!-- Third row -->
  <div class="cui-wizard__field-row">
    <!-- Challenge Question 1 -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-challenge-question')}} 1</label>
    <select v-model="userLogin.securityQuestion1" class="cui-dropdown" name="questions">
        <option
          v-for="entry in finalModel.data.challengeQuestions1"
          :key="entry.id"
          :value="entry.id"
        >{{ entry.question[0].text }}</option>
      </select>
    </div>

    <!-- Challenge Answer 1 -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-challenge-answer')}} 1</label>
       <div class="cui-error" v-if="$v.userLogin.answer1.$error && !$v.userLogin.answer1.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <div class="cui-error" v-else-if="$v.userLogin.answer1.$error && !$v.userLogin.answer1.isUnique" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.security-question-repeated')}}</div>
      </div>
        <input type="text" v-model="userLogin.answer1" @blur="$v.userLogin.answer1.$touch()"
       name="answer1" class="cui-input"/>
    </div>
  </div>

    <!-- Fourth row -->
  <div class="cui-wizard__field-row">
    <!-- Challenge Question 2 -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-challenge-question')}} 2</label>
          <select  v-model="userLogin.securityQuestion2"  class="cui-dropdown" name="questions">
        <option
          v-for="entry in finalModel.data.challengeQuestions2"
          :key="entry.id"
          :value="entry.id"
        >{{ entry.question[0].text }}</option>
      </select>
    </div>

    <!-- Challenge Answer 2 -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-challenge-answer')}} 2</label>
       <div class="cui-error" v-if="$v.userLogin.answer2.$error && !$v.userLogin.answer2.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <div class="cui-error" v-else-if="$v.userLogin.answer2.$error && !$v.userLogin.answer2.isUnique" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.security-question-repeated')}}</div>
      </div>
        <input type="text" v-model="userLogin.answer2" @blur="$v.userLogin.answer2.$touch()"
       name="answer2" class="cui-input"/>
    </div>
  </div>
</div>

</template>
<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate'
export default {
  props: ['finalModel'],
  data () {
    return {
      errors: {},
      count: 0,
      spinner: false,
      userLogin: {
        userId: '',
        password: '',
        securityQuestion1: 'S-OT-COE:1',
        answer1: '',
        securityQuestion2: 'S-OT-COE:4',
        answer2: ''
      }
    }
  },
  validations: {
    userLogin: {
      userId: {
        required,
        isUnique (value) {
          return new Promise((resolve, reject) => {
            this.spinner = true
            this.$API.initiateNonce().then(res => {
              this.$API.validateUsernameEmailNonce({qs: [['userName', value]]})
                .then(res => {
                  this.spinner = false
                  resolve(true)
                })
                .fail(error => {
                  this.spinner = false
                  console.log(error)
                  resolve(false)
                })
            })
              .fail(error => {
                this.spinner = false
                console.log(error)
                resolve(false)
              })
          })
        }
      },
      password: {
        required,
        isMinMax (value) {
          if (this.finalModel.passwordRules) {
            var exp = value.length <= this.finalModel.passwordRules.length.max && value.length >= this.finalModel.passwordRules.length.min
            return exp
          }
          return true
        },
        isLowerCase (value) {
          if (!value) return false
          if (this.finalModel.passwordRules && this.finalModel.passwordRules.characterClass.allowLowerChars) {
            var exp = (/.*[a-z].*/.test(value))
            if (this.count > this.finalModel.passwordRules.characterClass.requiredNumberOfCharClasses) {
              return true
            }
            return exp
          }
          return true
        },
        isUpperCase (value) {
          if (!value) return false
          if (this.finalModel.passwordRules && this.finalModel.passwordRules.characterClass.allowUpperChars) {
            var exp = (/.*[A-Z].*/.test(value))
            if (this.count > this.finalModel.passwordRules.characterClass.requiredNumberOfCharClasses) {
              return true
            }
            return exp
          }
          return true
        },
        isNumber (value) {
          if (!value) return false
          if (this.finalModel.passwordRules && this.finalModel.passwordRules.characterClass.allowNumChars) {
            var exp = (/.*[0-9].*/.test(value))
            if (this.count > this.finalModel.passwordRules.characterClass.requiredNumberOfCharClasses) {
              return true
            }
            return exp
          }
          return true
        },
        isSpecialChars (value) {
          if (!value) return false
          if (this.finalModel.passwordRules && this.finalModel.passwordRules.characterClass.allowSpecialChars) {
            var exp = !/^[a-z0-9]+$/i.test(value)
            if (this.count > this.finalModel.passwordRules.characterClass.requiredNumberOfCharClasses) {
              return true
            }
            return exp
          }
          return true
        },
        isRequiredNumberCharClass (value) {
          if (!value) {
            this.count = 0
            return false
          }
          if (this.finalModel.passwordRules) {
            if (this.$v.userLogin.password.isLowerCase) {
              this.count++
            }
            if (this.$v.userLogin.password.isUpperCase) {
              this.count++
            }
            if (this.$v.userLogin.password.isNumber) {
              this.count++
            }
            if (this.$v.userLogin.password.isSpecialChars) {
              this.count++
            }
            if (this.finalModel.passwordRules.characterClass.requiredNumberOfCharClasses <= this.count) {
              return true
            }
          }
          return false
        }
      },
      answer1: {
        required,
        isUnique (value) {
          if (value === this.userLogin.answer2) return false
          return true
        }

      },
      answer2: {
        required,
        isUnique (value) {
          if (value === this.userLogin.answer1) return false
          return true
        }
      },
      passwordRe: {
        required,
        sameAsPassword: sameAs(function () { return this.userLogin.password })

      }

    },
    form: ['userLogin.userId', 'userLogin.password', 'userLogin.password', 'userLogin.answer1',
      'userLogin.passwordRe', 'userLogin.answer2']
  },
  methods: {
    // validatePassword (event) {
    //   this.userLogin.password = event.target.value
    //   var value = this.userLogin.password
    //   this.errors.numberCharClass = 0
    //   this.errors.lengthVal = value.length <= this.finalModel.passwordRules.length.max && value.length >= this.finalModel.passwordRules.length.min
    //   if (this.finalModel.passwordRules.characterClass.allowUpperChars) {
    //     this.errors.lowerCaseAllowed = (/.*[a-z].*/.test(value))
    //     if (this.errors.lowerCaseAllowed) {
    //       this.errors.numberCharClass++
    //     }
    //   }
    //   if (this.finalModel.passwordRules.characterClass.allowUpperChars) {
    //     this.errors.upperCaseAllowed = (/.*[A-Z].*/.test(value))
    //     if (this.errors.upperCaseAllowed) {
    //       this.errors.numberCharClass++
    //     }
    //   }
    // if (this.finalModel.passwordRules.characterClass.allowSpecialChars) {

    // }
    // if (this.finalModel.passwordRules.characterClass.requiredNumberOfCharClasses) {

    // }
    // },
    validate () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    }
  },
  // watch: {
  //   userLogin: {
  //     password: function (val) {
  //       this.userLogin.password = val
  //     }
  //   }
  // },
  components: {
    Vuelidate
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/registration/userLogin.vue